export function dealerIdFromToken(token) {
  try {
    const part = token?.split(".")[1];
    if (!part) return null;
    const payload = JSON.parse(atob(part.replace(/-/g, "+").replace(/_/g, "/")));
    return payload.DealerId ?? payload.dealerId ?? null;
  } catch {
    return null;
  }
}

export function listingLabel(listing, currentDealerId) {
  return String(listing?.dealerId) === String(currentDealerId)
    ? "Your Current Listing"
    : "Current Meshum Listing";
}

export function listingComparisonText(analysis, formatCurrency) {
  if (!analysis || analysis.differenceAmount === null || analysis.differenceAmount === undefined) return null;
  const amount = formatCurrency(Math.abs(Number(analysis.differenceAmount)));
  if (analysis.pricePosition === "Near Estimate") return `Within ${amount} of Meshum Estimate`;
  return `${amount} ${Number(analysis.differenceAmount) < 0 ? "below" : "above"} Meshum Estimate`;
}
